import { OptionsIcon } from 'assets/icons';
import { classnames } from 'helpers/utils';
import styles from './filter-button.module.scss';

interface FilterButtonProps {
  onClick: () => void;
  isModalOpen: boolean;
  applyActiveFilterStyle: boolean;
}

export const FilterButton = ({
  onClick,
  isModalOpen,
  applyActiveFilterStyle,
}: FilterButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className={classnames(styles.icon, {
      [styles.activeFilters]: applyActiveFilterStyle,
      [styles.activeFiltersModalOpen]: isModalOpen,
    })}
  >
    <OptionsIcon />
  </button>
);
